import { BaseTool } from '../BaseTool';
import { openDocument, saveCurrentDocument } from '../../utils/ProjectFileIO';

export class NewProjectTool extends BaseTool {
    id = 'FILE_NEW';
    name = 'New Project';
    cursor = 'default';

    onActivate(): void {
        // Opens the template-driven New Project dialog (ProjectDialogsHost).
        window.dispatchEvent(new CustomEvent('yap:open-new-project-dialog'));
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class OpenProjectTool extends BaseTool {
    id = 'FILE_OPEN';
    name = 'Open Project';
    cursor = 'default';

    onActivate(): void {
        // Native OS Open dialog (File System Access API) with the in-app
        // file browser as fallback.
        void openDocument();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class SaveProjectTool extends BaseTool {
    id = 'FILE_SAVE';
    name = 'Save Project';
    cursor = 'default';

    onActivate(): void {
        // Writes to the current destination, or prompts for one when the
        // document was never saved (BIM Save/Save As behavior).
        void saveCurrentDocument();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
